import styled from 'styled-components';
import isEmpty from 'lodash/isEmpty';
import { HoverStyles, StyledDiv } from './OutfitCarouselModule.style';

const StyledDivV5 = styled(StyledDiv)`
  .tcp_carousel_wrapper {
    width: 90%;
    margin: 0px auto;
    margin-bottom: 40px;
  }
  .prevArr,
  .nextArr {
    opacity: 0.5;
  }
  .slick-prev,
  .slick-next {
    border: 1px solid #d8d8d8;
    border-radius: 50%;
    width: 40px;
    height: 40px !important;
  }
  @media ${(props) => props.theme.mediaQuery.medium} {
    .slick-prev,
    .slick-next {
      height: 40px;
    }
  }
  .subheading {
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XS_1};
    text-align: center;
    font-size: 20px;
    color: ${(props) => props.theme.colorPalette.blue[1300]};
    line-height: ${(props) => props.theme.spacing.ELEM_SPACING.LRG_2};
  }
  .carousel-image {
    margin: 0 auto 16px;
    box-sizing: border-box;
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    height: 100%;
    box-shadow: none;
  }
  .image-circle {
    border-radius: 100%;
    width: 134px;
    height: 134px;
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.XXM};
    outline: none;
    border: none;
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
    box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.12);
  }
  .image-link > pre {
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XS_1};
    line-height: ${(props) => props.theme.spacing.ELEM_SPACING.MED_2};
    padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XS_1};
    padding-left: ${(props) => props.theme.spacing.ELEM_SPACING.XS_1};
    padding-right: ${(props) => props.theme.spacing.ELEM_SPACING.XS_1};
    border: 2px solid ${(props) => props.theme.colors.WHITE};
    font-weight: ${(props) => props.theme.fonts.fontWeight.medium};
    font-size: ${(props) => props.theme.fonts.fontSize.anchor.medium};
    white-space: pre-wrap;
  }
  .image-link:hover > pre {
    @media ${(props) => props.theme.mediaQuery.medium} {
      ${HoverStyles}
    }
  }

  .image-circle:hover + a > pre {
    @media ${(props) => props.theme.mediaQuery.medium} {
      ${HoverStyles}
    }
  }

  .tile-container.active-category .image-link > pre {
    ${HoverStyles}
  }

  .subheading + div {
    display: block !important;
  }
  .tile-container {
    width: 100%;
    display: flex !important;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED_1};
    border: 2px solid ${(props) => props.theme.colors.WHITE};
  }

  .container-carousel > div {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin: 11px !important;
    }
  }
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    .image-circle {
      width: 125px;
      height: 125px;
      padding: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
    }
    .subheading {
      margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XS_1};
      font-weight: ${(props) => props.theme.fonts.fontWeight.semiBold};
      line-height: ${(props) => props.theme.spacing.ELEM_SPACING.MED_2};
    }

    .image-link > pre {
      font-weight: ${(props) => props.theme.fonts.fontWeight.semiBold};
      line-height: ${(props) => props.theme.spacing.ELEM_SPACING.MED_1};
    }
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    .subheading {
      margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XXML};
      padding-right: 290px;
    }
  }
  @media ${(props) => props.theme.mediaQuery.desktop} {
    .image-circle {
      width: 180px;
      height: 180px;
      padding: 6px;
    }
  }
  ${(props) => (!isEmpty(props.spacingTop) ? `margin-top: ${props.spacingTop}px;` : ``)}
  ${(props) => (!isEmpty(props.spacingBottom) ? `margin-bottom: ${props.spacingBottom}px;` : ``)}
`;

export default StyledDivV5;
